import React from 'react';
import { Field } from 'react-final-form';
import { useTranslation } from 'react-i18next';

import WithLabel, { LABEL_STYLES } from '../../../../components/with-label/WithLabel';
import CommonSwitch from '../../../../components/common-switch/CommonSwitch';
import Id8AgentFields from '../../../project-create/id8/Id8AgentFields';

function Id8NameFormInner() {
  const { t } = useTranslation('projects');

  return (
    <>
      <Field name='thinking' autoComplete='id8-thinking' type='checkbox'>
        {({ input }) => (
          <WithLabel variant={LABEL_STYLES.ROW} label={`${t('thinking')}:`} isBold>
            <CommonSwitch checked={input.checked} onChange={input.onChange} />
          </WithLabel>
        )}
      </Field>

      <Id8AgentFields />
    </>
  );
}

export default Id8NameFormInner;
